// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e7YU","newExpiryDate":"styles_newExpiryDate__3gj3S","footer":"styles_footer__3r0hu"};